import { Component, OnInit } from '@angular/core';
import { Announcement } from '@app/announcements/shared/models/announcement';
import { AnnouncementService } from '@app/announcements/shared/services/announcement.service';

@Component({
	selector: 'kpa-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
	public viewAnnouncement: boolean = false;
	public recentAnnouncements: Announcement[] = [];

	constructor(private announcementService: AnnouncementService) {}
	ngOnInit(): void {
		this.announcementService.getRSSSystemList().subscribe((result: Announcement[]) => {
			this.recentAnnouncements = this.filterRecentAnnouncements(result, 7);
			this.viewAnnouncement = this.recentAnnouncements && this.recentAnnouncements.length > 0;
		});
	}
	filterRecentAnnouncements = (announcements: any[], days: number): any[] => {
		const today = new Date();
		const thresholdDate = new Date(today);
		thresholdDate.setDate(today.getDate() - days);

		return announcements.filter((announcement) => {
			const announcementDate = new Date(announcement.dateAdded);
			return announcementDate >= thresholdDate;
		});
	};
}
